'use client';

import { getCookie } from '../Utils/cookie.js';
import { objToQueryStr } from '../Utils/urlBuilder.js';
import { VNW_TRACKING_GA, VNW_TRACKING_GA_FIRST } from './const.js';
import { slugify } from '../Utils/helpers.js';

var getUTMTracking = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    try {
        var vnwTrackingGA = getCookie(VNW_TRACKING_GA);
        var vnwTrackingGAFirst = getCookie(VNW_TRACKING_GA_FIRST);
        var utmGA = JSON.parse(decodeURIComponent(vnwTrackingGA !== null && vnwTrackingGA !== void 0 ? vnwTrackingGA : '{}'));
        var queryParamsUtmGA = objToQueryStr(utmGA);
        var headderUtmsGA = {
            'X-Tracking-UTM-Campaign': (_a = utmGA.utm_campaign) !== null && _a !== void 0 ? _a : '',
            'X-Tracking-UTM-Content': (_b = utmGA.utm_content) !== null && _b !== void 0 ? _b : '',
            'X-Tracking-UTM-Datetime': (_c = utmGA.utm_datetime) !== null && _c !== void 0 ? _c : '',
            'X-Tracking-UTM-Medium': (_d = utmGA.utm_medium) !== null && _d !== void 0 ? _d : '',
            'X-Tracking-UTM-Referer': (_e = utmGA.utm_referer) !== null && _e !== void 0 ? _e : '',
            'X-Tracking-UTM-Source': (_f = utmGA.utm_source) !== null && _f !== void 0 ? _f : '',
            'X-Tracking-UTM-Term': (_g = utmGA.utm_term) !== null && _g !== void 0 ? _g : '',
            'X-Tracking-UTM-Url': (_h = utmGA.utm_url) !== null && _h !== void 0 ? _h : ''
        };
        var utmGAFirst = JSON.parse(decodeURIComponent(vnwTrackingGAFirst !== null && vnwTrackingGAFirst !== void 0 ? vnwTrackingGAFirst : '{}'));
        var headerUtmsGAfirst = {
            'X-Tracking-UTM-Campaign-First': (_j = utmGAFirst.utm_campaign) !== null && _j !== void 0 ? _j : '',
            'X-Tracking-UTM-Content-First': (_k = utmGAFirst.utm_content) !== null && _k !== void 0 ? _k : '',
            'X-Tracking-UTM-Datetime-First': (_l = utmGAFirst.utm_datetime) !== null && _l !== void 0 ? _l : '',
            'X-Tracking-UTM-Medium-First': (_m = utmGAFirst.utm_medium) !== null && _m !== void 0 ? _m : '',
            'X-Tracking-UTM-Referer-First': (_o = utmGAFirst.utm_referer) !== null && _o !== void 0 ? _o : '',
            'X-Tracking-UTM-Source-First': (_p = utmGAFirst.utm_source) !== null && _p !== void 0 ? _p : '',
            'X-Tracking-UTM-Term-First': (_q = utmGAFirst.utm_term) !== null && _q !== void 0 ? _q : '',
            'X-Tracking-UTM-Url-First': (_r = utmGAFirst.utm_url) !== null && _r !== void 0 ? _r : ''
        };
        return {
            queryParamsUtmGA: queryParamsUtmGA,
            headderUtmsGA: headderUtmsGA,
            headerUtmsGAfirst: headerUtmsGAfirst
        };
    }
    catch (error) {
        console.log(error);
        return null;
    }
};
var getJobUrlParams = function (link) {
    if (!link)
        return '';
    var urlSearch = link.split('?');
    if (!urlSearch || urlSearch.length < 1)
        return '';
    return urlSearch[1];
};
var applySuccessLink = function (baseUrl, t, jobInfo) {
    if (typeof window === undefined)
        return;
    var searchParams = new URLSearchParams(window.location.href);
    var isHaveCompetitiveParam = !!searchParams.has('applycompetitive');
    var alias = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.alias) || slugify((jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobTitle) || '');
    var link = "".concat(baseUrl).concat(t('/success-apply'), "/").concat(alias, "-").concat(jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobId).concat(isHaveCompetitiveParam ? '?applycompetitive' : '');
    return link;
};

export { applySuccessLink, getJobUrlParams, getUTMTracking };
//# sourceMappingURL=helper.js.map
